import React from 'react';

import * as cache from '../services/reportCache';
import * as utils from '../utils/utilities';

import logger from '../services/logService';

const useCachedReport = (reportDetails: any) => {
	const [report, setReport] = React.useState<any>(reportDetails);

	React.useEffect(() => {
		const initializeProjectReport = async () => {
			if (!reportDetails.projectDetails) return;

			const projectId: string = reportDetails.projectDetails._id;
			try {
				const { data: cachedReport} = await cache.getReportCacheProgress(projectId);
				const details = cachedReport
					? utils.copyUpdatedData(cachedReport.value, reportDetails)[0]
					: { ...reportDetails };

				setReport(details);
			} catch (error) {
				logger.log(error as Error);
			}
		};

		initializeProjectReport();
	}, [reportDetails]);

	return report;
};

export default useCachedReport;
